module.exports = __webpack_public_path__ + "static/img/4.2490ca1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/4.jpg
// module id = 422
// module chunks = 1